import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { FileManager } from 'components/FileManager'
import { ModalConfirmacao } from 'components'

export const ModalUploadExame = (props) => {
  const {
    aberto,
    onClose,
    onConfirm,
    processando,
    arquivosUpload,
    setArquivosUpload
  } = props

  const isDisabled = !arquivosUpload || arquivosUpload.length !== 1

  return (
    <ModalConfirmacao
      aberto={aberto}
      onClose={onClose}
      onConfirm={onConfirm}
      processando={processando}
      disabled={isDisabled}
      titulo="UPLOAD DE ARQUIVO"
      confirmarLabel="Confirmar"
      maxWidth="sm"
    >
      <div style={{ marginTop: '10px' }}>
        <Grid item xs={12}>
          <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginBottom: '15px' }}>
            ATENÇÃO: Os exames que forem realizados de forma independente não terão os mecanismos de segurança fornecidos pelo sistema.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <FileManager
            rotaUpload="/arquivo/documentoExameRealizado"
            rotaLoadImagem="/arquivo/documentoExameRealizado"
            setArquivosPai={setArquivosUpload}
            arquivosIniciais={[]}
            tipos={['pdf']}
            multiple={false}
            center={true}
          />
        </Grid>
      </div>
    </ModalConfirmacao>
  )
}
